import React from "react";
import { Logo, ellips, tutorIcons } from "../../assets";
import {Input, Button} from './../../components/Generic'

const Register = () => {
  return (
    <section className="px-5 font-inter max-w-[428px] flex justify-center">
      <div className="flex flex-col items-center justify-center">
        <div className="mt-12">
          <img src={Logo} alt="Logo"/>
          <p className="mt-5 text-gray-lightGray text-15px">TutorChat</p>
        </div>
        <div className="flex justify-between w-full my-16">
            <div className="">
                <h3 className="text-[20px] font-medium">Register</h3>
                <p className="text-15px text-gray-lightGray mt-[14px]">Hello, Welcome to TutorChat!</p>
            </div>
            <div className="">{tutorIcons.userAvatar}</div>
        </div>
        <form className="sm:w-[387px] w-full">
      <img className="absolute top-[40%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
      <Input type={"email"} id={"email"} placeholder={"Username"} style={`text-gray-lightGray text-base py-4 px-[18px]`} />
      <Input type={"password"} id={"password"} placeholder={"Create password"} style={`text-gray-lightGray text-base py-4 px-[18px]`} />
      <Input type={"password"} id={"password"} placeholder={"Confirm password"} style={`text-gray-lightGray text-base py-4 px-[18px]`} />
      <Button style={`mb-[100px] mt-[50px]`} link={'/start'} value={'Register'}/>

    </form>
      </div>
    </section>
  );
};

export default Register;
